enum DEP_MODE {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}

enum DEP_TYPE {
  SCRIPT = 'script',
  STYLES = 'styles',
}

type TAttr = string | string[] | null

// Script to load dependencies (js and css) into website for every section
const loadDependence = (
  type: string,
  name: string,
  loadedVariable: string[],
) => {
  // Check if elements is already added (if is in loaded*Name* variable)
  let path = ''

  // Get correct path depends of type from meta tag
  const mode = document
    .querySelector("[name='bw:dependencies']")
    ?.getAttribute('content')

  switch (mode) {
    case DEP_MODE.DEVELOPMENT:
      path = 'assets/'
      break
    case DEP_MODE.PRODUCTION:
      path = '/'
      break
  }

  if (loadedVariable.indexOf(name) === -1) {
    // If not, add element to variable
    loadedVariable.push(name)

    // Find specific file

    let file
    if (type === DEP_TYPE.SCRIPT) {
      file = path + 'js/' + name + '.js'
      const script = document.createElement('script') // create a script DOM node
      script.type = 'text/javascript'
      script.src = file // set its src to the provided URL

      document.head.appendChild(script)
    }

    if (type === DEP_TYPE.STYLES) {
      file = path + 'css/' + name + '.css'
      // Create DOM link element
      const style = document.createElement('link')
      style.rel = 'stylesheet'
      style.media = 'print'
      style.setAttribute('onload', "if(media!='all')media='all'")
      style.href = file // set its src to the provided URL

      document.head.appendChild(style)
    }
  } else {
    // console.log(name + "  loaded");
  }
}

// Helper variables for list of already loaded styles and scripts
const loadedScripts = ['']
const loadedStyles = ['']

// Init loadDependence for every data-style and data-script attr
const dataStyles = document.querySelectorAll('[data-styles]')

// Loop through elements with dataStyles
dataStyles.forEach((e) => {
  // Get names of scripts from data script
  let styles: TAttr = e.getAttribute('data-styles')

  if (styles === null) return

  // Split styles to array
  styles = styles.split(' ')

  // Loop through specified dependences, and execute loadDependence function for every
  styles.forEach((e) => {
    loadDependence('styles', e, loadedStyles)
  })
})

const dataScripts = document.querySelectorAll('[data-scripts]')

// Loop through elements with dataStyles
dataScripts.forEach((e) => {
  // Get names of scripts from data script
  let scripts: TAttr = e.getAttribute('data-scripts')

  if (scripts === null) return

  // Split styles to array
  scripts = scripts.split(' ')

  // Loop through specified dependences, and execute loadDependence function for every
  scripts.forEach((e) => {
    loadDependence('script', e, loadedScripts)
  })
})
